import React from "react";
import BaseLayout from "./BaseView/BaseLayout";
import GridItem from "../components/Grid/GridItem";
import Card from "../components/Card/Card";
import GridContainer from "../components/Grid/GridContainer";

import styles from "assets/jss/material-kit-pro-react/views/loginPageStyle.js";
import {withSnackbar} from "notistack";
import {withStyles} from "@material-ui/core";
import CardHeader from "../components/Card/CardHeader";
import CardBody from "../components/Card/CardBody";
import CustomInput from "../components/CustomInput/CustomInput";
import InputAdornment from "@material-ui/core/InputAdornment";
import Email from "@material-ui/core/SvgIcon/SvgIcon";
import CardFooter from "../components/Card/CardFooter";
import Divider from '@material-ui/core/Divider';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';

import Button from "components/CustomButtons/Button.js";

import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import {chekcOrder, createPayMethodPrice, getUserName, subscribe} from "../utils/request";
import Rose from "../components/Typography/Rose";
import {Info} from "@material-ui/icons";
import Tooltip from "@material-ui/core/Tooltip";

import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Slide from "@material-ui/core/Slide";
import Close from "@material-ui/icons/Close";
import Box from "@material-ui/core/Box";

import javascriptStyles
	from "assets/jss/material-kit-pro-react/views/componentsSections/javascriptStyles.js";
import Warning from "../components/Typography/Warning";
import storage from "../utils/storage";

const useStyles = javascriptStyles;


function isEmpty(object) {
	if (object === null || object === undefined) {
		return true;
	}

	return false;
}

class CreatePay2 extends React.Component {


	constructor(props, context) {
		super(props, context);

		const _planId = this.props.match.params.planId;

		this.state = {
			planId: _planId,
			promeCode: '',
			promeCode_errStatus: false,
			inSend: false,
			showPayChoose: false,
			payMethod: 'ali',
			subscribeType: 'year',
			showAmount: '179',
			userName: '',
		};


		if (isEmpty(storage.get("token"))) {
			this.props.history.push('/login');
		}

		document.title = "订阅内容 - RobinAlgo";
		this.initOrder();
	}


	openPayChoose = () => {
		this.setState({
			showPayChoose: true,
		})
	};

	closeChoosePay = () => {
		this.setState({
			showPayChoose: false,
		})
	};


	onChoosePay = () => {

	};


	handleChange = (event) => {
		const field = event.target.id;
		if (field === 'prome') {
			this.setState({promeCode: event.target.value});
		}
	};

	subSubscribe = () => {
		let utc =
			// 'UTC+' +
			(0 - new Date().getTimezoneOffset() / 60);
		subscribe(this.state.subscribeType, this.state.payMethod, utc)
			.then(res => {
				if (!res.data.effective) {
					this.props.enqueueSnackbar('当前请求异常, 请刷新后重试', {variant: 'error'});
				} else {
					this.props.history.push('/in_pay/create/' + res.data.orderId);
				}
			})
	}


	initOrder = () => {
		getUserName().then(res => {
			this.setState({
				userName: res.data
			})
		})
	};

	changePlan = (event) => {
		this.setState({
			subscribeType: event.target.value
		})
		switch (event.target.value) {
			case "year":
				this.setState({
					showAmount: 179
				});
				break;
			case "halfYear":
				this.setState({
					showAmount: 99
				});
				break;
			case "quarterYear":
				this.setState({
					showAmount: 55
				});
				break;
			case "month":
				this.setState({
					showAmount: 20
				});
				break;
			default:
				this.setState({
					showAmount: 179
				});
				break;
		}
		// console.log("value: " +)
	};

	render() {

		return (
			<BaseLayout>
				<GridContainer justify="center">
					<GridItem xs={12} sm={9} md={9} lg={9}
							  style={{
								  backgroundColor: '#fff',
								  borderRadius: "20px",
								  border: "2px solid #f5f5f5",
								  color: '#000',
								  padding: '32px'
							  }}>
						<GridContainer style={{marginBottom: '32px'}}>
							<GridItem
								xs={6} sm={6} md={2} lg={2}
								style={{fontSize: '11pt'}}>
								用户账号:
							</GridItem>
							<GridItem
								xs={6} sm={6} md={10} lg={10}
								style={{fontSize: '11pt'}}>
								{this.state.userName}
							</GridItem>
						</GridContainer>
						<GridContainer style={{marginBottom: '16px'}}>
							<GridItem
								xs={6} sm={6} md={2} lg={2}
								style={{fontSize: '11pt'}}>
								开通时长:
							</GridItem>
							<GridItem
								xs={6} sm={6} md={10} lg={10}
								style={{fontSize: '11pt', marginTop: '-16px'}}>

								<RadioGroup row defaultValue="year" style={{marginLeft: '-32px'}}
											onChange={(e) => this.changePlan(e)}>
									<FormControlLabel value="year"
													  control={<Radio/>} label={

										<Card
											style={{
												fontSize: '12pt',
												paddingLeft: '16px',
												paddingRight: '16px',
												width: '100%'
											}}>
											<CardBody>
												<GridItem>
													365天
												</GridItem>
												<GridItem style={{
													fontSize: '14pt',
													marginTop: '8px',
													marginBottom: '8px'
												}}>
													<b>¥179</b>
												</GridItem>
												<GridContainer justify="flex-end">
													<small>仅¥0.49/天</small>
												</GridContainer>
											</CardBody>
										</Card>
									}
													  style={{marginTop: '-32px', minWidth: '40%'}}
									/>

									<FormControlLabel value="halfYear"
													  control={<Radio/>} label={

										<Card
											style={{
												fontSize: '12pt',
												paddingLeft: '16px',
												paddingRight: '16px',
												width: '100%'
											}}>
											<CardBody>
												<GridItem>
													180天
												</GridItem>
												<GridItem style={{
													fontSize: '14pt',
													marginTop: '8px',
													marginBottom: '8px'
												}}>
													<b>¥99</b>
												</GridItem>
												<GridContainer justify="flex-end">
													<small>仅¥0.55/天</small>
												</GridContainer>
											</CardBody>
										</Card>
									}
													  style={{marginTop: '-32px', minWidth: '40%'}}
									/>

									<FormControlLabel value="quarterYear"
													  control={<Radio/>} label={

										<Card
											style={{
												fontSize: '12pt',
												paddingLeft: '16px',
												paddingRight: '16px',
												width: '100%'
											}}>
											<CardBody>
												<GridItem>
													90天
												</GridItem>
												<GridItem style={{
													fontSize: '14pt',
													marginTop: '8px',
													marginBottom: '8px'
												}}>
													<b>¥55</b>
												</GridItem>
												<GridContainer justify="flex-end">
													<small>仅¥0.61/天</small>
												</GridContainer>
											</CardBody>
										</Card>
									}
													  style={{marginTop: '-32px', minWidth: '40%'}}
									/>

									<FormControlLabel value="month"
													  control={<Radio/>} label={

										<Card
											style={{
												fontSize: '12pt',
												paddingLeft: '16px',
												paddingRight: '16px',
												width: '100%'
											}}>
											<CardBody>
												<GridItem>
													30天
												</GridItem>
												<GridItem style={{
													fontSize: '14pt',
													marginTop: '8px',
													marginBottom: '8px'
												}}>
													<b>¥20</b>
												</GridItem>
												<GridContainer justify="flex-end">
													<small>仅¥0.67/天</small>
												</GridContainer>
											</CardBody>
										</Card>
									}
													  style={{marginTop: '-32px', minWidth: '40%'}}
									/>

								</RadioGroup>

							</GridItem>
						</GridContainer>


						<GridContainer style={{marginBottom: '16px'}}>
							<GridItem
								xs={6} sm={6} md={2} lg={2}
								style={{fontSize: '11pt'}}>
								支付方式:
							</GridItem>
							<GridItem
								xs={6} sm={6} md={10} lg={10}
								style={{fontSize: '11pt', marginLeft: '-32px', marginTop: '-16px'}}>
								<RadioGroup value={this.state.payMethod}
											style={{marginTop: '24px'}}>

									<FormControlLabel
										value="ali"
										control={<Radio/>}
										label={
											<Box display="flex" alignItems="center">
												<Box>
													<img
														style={{width: '150px', height: 'auto'}}
														src={"https://robinalgo.oss-cn-shanghai.aliyuncs.com/images/icon_ali_pay.png"}
														alt={""}/>
												</Box>
											</Box>
										}/>

								</RadioGroup>
							</GridItem>
						</GridContainer>

						<GridContainer justify="flex-end"
									   style={{fontSize: '14pt', color: '#0e0e0e'}}>
							支付金额: &nbsp;&nbsp;&nbsp;&nbsp; <Rose><b
							style={{fontSize: '20pt'}}>¥{this.state.showAmount}</b></Rose>
						</GridContainer>

						<GridContainer justify="flex-end" style={{marginTop: '16px'}}>
							<Button color={"primary"} onClick={this.subSubscribe}>
								立即支付
							</Button>
						</GridContainer>
					</GridItem>


					<GridItem xs={12} sm={2} md={2} lg={2}
							  style={{
								  backgroundColor: '#fff',
								  borderRadius: "20px",
								  border: "2px solid #f5f5f5",
								  marginLeft: "10px",
								  color: '#000',
								  padding: '16px'
							  }}>
						<GridContainer justify={'center'}>
							<img src={"https://robinalgo.oss-cn-shanghai.aliyuncs.com/logo512.png"}
								 style={{width: "40%", height: "auto"}}/>
						</GridContainer>
						<h5>RobinAlgo会员权益</h5>
						<li style={{color: '#686868', fontSize: "10pt"}}>100+完整的视频观看</li>
						<li style={{color: '#686868', fontSize: "10pt"}}>完整的题目可视化动画展示</li>
						<li style={{color: '#686868', fontSize: "10pt"}}>相关代码及内容的查看</li>
						<li style={{color: '#686868', fontSize: "10pt"}}>黑板手绘展示题目讲解思路</li>
						<li style={{color: '#686868', fontSize: "10pt"}}>每行代码详细注释解答</li>
					</GridItem>
				</GridContainer>
			</BaseLayout>
		)
	}
}


export default withStyles(useStyles)(withSnackbar(CreatePay2))